export default class CompleteBillingInformationService {
  static hasToCompleteBillingInfo(minimum_payout, payment_method) {
    return !minimum_payout && !payment_method;
  }
}
